import { eHOAFees } from '../../../ui-toolkit/enums/eHOAFees';

export default function generateHOAFeesOptions() {
  return Object.entries({
    'HOA - Working Capital': eHOAFees.working_capital,
    'HOA - Prepaid Assmt': eHOAFees.prepaid_assessment,
    'HOA - Special Assmt': eHOAFees.special_assessment,
    'HOA - Disclosure Fee': eHOAFees.disclosure_fee,
    'HOA - Transfer Fee': eHOAFees.transfer_fee,
    'HOA - Service Fee': eHOAFees.service_fee,
  }).map((entry) => ({ label: entry[0], value: entry[1] }));
}
